import { Modal } from '../../modules/a11y-modal';
import { unlockBody } from '../../helpers/lockBody';
import axios from 'axios';

const hostedPaymentModalElement = document.querySelector<HTMLElement>("#hosted-payment-modal");

export const initializePayment = () => {
    if (hostedPaymentModalElement) {
        var hostedPaymentModal = new Modal(hostedPaymentModalElement);
        hostedPaymentModal.modal.show();

        hostedPaymentModal.modal.on('hide', () => {
            var requestString: string = '/ace-api/tmsdonate/logout';

            axios.post(requestString, null, {
                method: "POST",
                withCredentials: true
            }).then(response => response.data);

            unlockBody(hostedPaymentModal.bodyStyles);
        });
    }
}